import { Typography } from "@mui/material"

export default function InfoText(props: any) {

    let content = <></>

    switch (props.infoPopup.id) {
        case "FLAECHENAUSWAHL":

            content = <>

                Wählen Sie hier die Flächenarten die angezeigt werden sollen und auf die sich die jeweiligen Waldinformationen im Dashboard beziehen sollen:

                <p><b>Arnsberg:</b> Waldfläche des gesamten Stadtgebiets.</p>
                <p><b>Flurstücke:</b> Parzellen des amtlichen Liegenschaftskataster mit Waldbestand.</p>
                <p><b>Stadtwald Arnsberg:</b> Forstwirtschaftliche Einheiten (Forsteinrichtungsflächen) des Stadtwald Arnsberg.</p>

            </>
            break;
        case "WALDINFORMATIONEN":

            content = <>
                Wählen Sie hier verschiedene Informationsebenen des Arnsberger Waldes:
                <p><b>Waldtypen:</b> Mittels Sentinel-2 Satellitendaten abgeleitete Waldmaske in 10m räumlicher Auflösung mit Unterscheidung von Laubbaum- und Nadelbaum-dominierten Waldbeständen für das Referenzjahr 2016.</p>
                <p><b>Baumhöhen:</b> Mittels amtlicher Luftbild- und Laserscanning-Daten abgeleitete Höheninformation der Baumbestände mit 20cm räumlicher Auflösung für 2020/21 (Stadtgebiet Arnsberg wurde teilweise 2020 und 2021 beflogen). Die Baumhöheninformation ist mit der Waldfläche 2016 maskiert.</p>
                <p><b>Biomasse:</b> Geschätzte oberirdische Biomasse der Waldbestände in 20m räumlicher Auflösung für 2020/21. Zur Modellierung der Biomasse wurde zunächst ein Verfahren der künstlichen Intelligenz zur Erkennung von Einzelbäumen aus Luftbildern angewendet. Diese Einzelbaumerkennung wurde dann kombiniert mit der Baumhöheninformation sowie mit Referenzdaten der Bundeswaldinventur.</p>
                <p><b>Kohlenstoffspeicher:</b> Auf Basis der modellierten oberirdischen Biomasse der Waldbestände wurde der Kohlenstoffspeicher der Wälder geschätzt.</p>
            </>
            break;
        case "WALDZUSTAND":

            content = <>
                Wählen Sie hier verschiedene Informationsebenen des Arnsberger Waldes:
                <p>
                    <b>
                        Waldvitalität:
                    </b>&nbsp;
                    Diese Karten zeigen die Vitalitätsveränderungen der Waldbestände für den jeweils ausgewählten Zeitraum, wobei Vitalitätsverluste in gelb bis rot (rot zeigt meist völligen Verlust der lebenden Biomasse) und Vitalitätsverbesserungen/Biomassezuwächse in grün dargestellt sind. Diese Information wurde mittels einer Trendanalyse basierend auf Sentinel-2 Vegetationsindex-Zeitreihen aus dem jeweiligen Zeitraum abgeleitet.
                </p>
                <p>
                    <b>
                        Laubwald Wasserhaushalt:
                    </b>&nbsp;
                    Manche Laubbaumbestände haben unter der Trockenheit der letzten Jahre gelitten. Der Grad des Trockenstresses hängt von vielen Faktoren ab, wie z.B. makro- und mikroklimatischen Begebenheiten, Hangneigung und –exposition, Baumarten, Bodeneigenschaften etc. Diese Karten zeigen den Trend der Wasserbilanz von Laubwaldbeständen für den jeweils ausgewählten Zeitraum. Diese Information wurde mittels einer Trendanalyse basierend auf Sentinel-2 Vegetationsindex-Zeitreihen aus dem jeweiligen Zeitraum abgeleitet.
                </p>
                <p>
                    <b>
                        Schadflächen:
                    </b>&nbsp;
                    Kalamitäts- und Holzeinschlagsflächen mit einem Verlust der lebenden Waldbiomasse im jeweils ausgewählten Zeitraum. Die Schadflächen zeigen meist Kahlflächen oder Flächen komplett abgestorbener oberirdischer Waldbiomasse.
                </p>
            </>
            break;
        case "NDVI":
            content = <>
    Dieser Graph zeigt den Monatsmittelwert des Vegetationsindex NDVI (Normalized Difference Vegetation Index) für alle Waldbestände innerhalb der ausgewählten Fläche. Der NDVI ist ein etablierter Indikator für die photosynthetische Aktivität von Vegetation und gibt hier die Vitalität von Wäldern wieder. Dieser wurde mittels Sentinel-2 Satellitendaten mit 10m räumlicher Auflösung berechnet. Die Linie zeigt den Trend über den ausgewählten Zeitraum. Die daraus resultierende Veränderung des Trends (positiv/neutral/negativ) im ausgewählten Zeitraum wird rechts in der Farbskala indiziert.
            </>
            break;
        case "NDWI":
            content = <>
Dieser Graph zeigt den Monatsmittelwert des Vegetationsindex NDWI (Normalized Difference Water Index) für alle Laubwaldbestände 
innerhalb der ausgewählten Fläche. Falls es keine Laubwaldbestände in der ausgewählten Fläche gibt, wird der Wert durchgehend mit 0 angezeigt.
Der NDWI ist ein Indikator für den Wassergehalt der grünen Blattbiomasse und gibt somit Hinweise auf 
möglichen Trockenstress von Laubwäldern. Der NDWI wurde mittels Sentinel-2 Satellitendaten mit 10m räumlicher Auflösung berechnet. Die 
Linie zeigt den Trend über den ausgewählten Zeitraum. Die daraus resultierende Veränderung des Trends (positiv/neutral/negativ) im ausgewählten
Zeitraum wird rechts in der Farbskala indiziert. 
            </>
            break;
    }

    return (
        <>
            <Typography>
                {content}
            </Typography>
        </>
    );
}

